/**
 * LayerToggles — a map-style control cluster to switch overlay layers on/off.
 */

import { Radio, Gauge, Waypoints } from "lucide-react";
import type { OverlayLayers } from "./layers.js";

const LAYERS: Array<{ key: keyof OverlayLayers; label: string; icon: React.ReactNode }> = [
  { key: "runs", label: "Runs", icon: <Radio className="h-4 w-4" /> },
  { key: "stats", label: "Stats", icon: <Gauge className="h-4 w-4" /> },
  { key: "events", label: "Activity", icon: <Waypoints className="h-4 w-4" /> },
];

export function LayerToggles({
  layers,
  onToggle,
}: {
  layers: OverlayLayers;
  onToggle: (key: keyof OverlayLayers) => void;
}) {
  return (
    <div className="overlay-panel pointer-events-auto flex items-center gap-1 rounded-2xl p-1">
      {LAYERS.map(({ key, label, icon }) => {
        const on = layers[key];
        return (
          <button
            key={key}
            onClick={() => onToggle(key)}
            aria-pressed={on}
            title={`${on ? "Hide" : "Show"} ${label}`}
            className={`flex min-h-[36px] items-center gap-1.5 rounded-xl px-3 py-1.5 text-xs font-medium transition-[background-color,color,scale] duration-200 active:scale-[0.96] ${
              on
                ? "bg-accent/15 text-text-primary"
                : "text-text-muted hover:bg-white/5 hover:text-text-secondary"
            }`}
          >
            {icon}
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
}
